import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, fonts, spacing } from '../../../constants';
import { ANIMATION_KEYFRAMES } from '../../../constants/promotionalSection';

/**
 * PromotionalHeading Component
 * Main heading section with title and subtitle
 * 
 * @param {string} title - Main title
 * @param {string} subtitle - Subtitle text
 */
const PromotionalHeading = ({ title, subtitle }) => {
  return (
    <Box
      sx={{
        animation: 'fadeInDown 0.8s ease-out',
        '@keyframes fadeInDown': ANIMATION_KEYFRAMES.fadeInDown,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { md: '28px', lg: '32px' },
          fontWeight: fonts.weightBold,
          color: colors.textWhite,
          mb: spacing.sm,
          lineHeight: 1.2,
          letterSpacing: '-0.02em',
          textAlign: 'left',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: fonts.descriptionSize,
          fontWeight: fonts.weightNormal,
          color: colors.textWhite,
          textAlign: 'left',
          lineHeight: 1.5,
          opacity: 0.95,
          textShadow: '0 1px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default PromotionalHeading;
